import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    topups_container: {
        display: 'flex',
        flexDirection: 'column',
    },
    topups_table: {
        display: 'flex',
        flexDirection: 'column',
    },
    client_receipt_btn: {
        position: 'absolute',
        top: '6px',
        marginLeft: '65px',
        color: theme.palette.grey['600'],
        "&:hover": {
            color: theme.palette.grey['800']
        }
    },
    elements_container: {},
    topups_info_container: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: '170px auto 200px 150px 210px 145px 150px 50px',
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        "&:hover": {
            backgroundColor: `${theme.palette.grey[100]}`,
            cursor: 'pointer',
        }
    },
    order_number_text: {
        paddingTop: '2px'
    },
    pending:{
        borderLeft: `8px solid ${theme.palette.grey["400"]}`,
    },
    done:{
        borderLeft: `8px solid ${theme.palette.success.light}`,
    },
    error:{
        borderLeft: `8px solid ${theme.palette.error.light}`,
    },
    topups_info_container_small: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        placeItems: 'stretch',
        rowGap: 16,
        columnGap: 16,
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
    },
    inactive: {
        borderLeft: `8px solid ${theme.palette.grey["300"]}`,
        backgroundColor: `${theme.palette.grey["300"]}8c`,
        opacity: '0.8'
    },
    menu_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        "& > *": {
            marginLeft: '4px'
        }
    },
    menu_container_small: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        "& > *": {
            marginLeft: '4px'
        }
    },
    filter_container: {
        display: "grid",
        gridTemplateColumns: "repeat( auto-fit, minmax(280px, 1fr))",
        rowGap: 16,
        columnGap: 8,
        "& button": {
            justifySelf: "end"
        }
    },
    tools_container: {
        marginTop: '16px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    filter_buttons_container: {
        display: "flex",
        justifyContent: "end",
        gridColumn: '1 / -1'
    },
    search_btn: {
        justifySelf: 'flex-end',
        marginLeft: '5px'
    },
    margin_top_8: {
        marginTop: '8px'
    },
    first_row_small: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    margin_top_4: {
        marginTop: '4px'
    },
    hide_small: {
        "@media (max-width: 800px)": {
            display: 'none'
        }
    },
    options_container: {
        display: 'flex'
    },
    select_all_checkbox: {
        marginLeft: '15px',
        marginRight: '10px'
    },
    margin_left_download_btn: {
        marginLeft: '20px'
    },
    order_number_container: {
        display: 'flex',
    },
}));

export {useStyles}